
import { Button } from "@/components/ui/button";
import { ConfirmationHeader } from "./confirmation/ConfirmationHeader";
import { OrderSummary } from "./confirmation/OrderSummary";
import { useConfirmationStatus } from "./confirmation/useConfirmationStatus";
import { useNavigate } from "react-router-dom";

interface ConfirmationScreenProps {
  subscription: {
    id: string;
    medication: string;
    plan_type: string;
    amount: number;
    status: string;
    dose_type?: "standard" | "max";
    discounted_amount?: number;
    applied_promo_code?: string;
  };
}

export const ConfirmationScreen = ({ subscription }: ConfirmationScreenProps) => {
  useConfirmationStatus(subscription);
  const navigate = useNavigate();

  // GTM tracking is now handled by PaymentSuccessHandler - no duplicate events here

  const handleReturnToDashboard = () => {
    navigate('/dashboard', { replace: true });
  };

  if (!subscription) {
    return (
      <div className="text-center">
        <p className="text-red-500">Error loading order details. Please contact support if this persists.</p>
        <Button
          variant="link"
          onClick={handleReturnToDashboard}
          className="mt-4"
        >
          Return to Dashboard
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <ConfirmationHeader medication={subscription.medication} />
      <OrderSummary 
        medication={subscription.medication}
        planType={subscription.plan_type}
        amount={subscription.amount}
        doseType={subscription.dose_type}
        discountedAmount={subscription.discounted_amount}
        appliedPromoCode={subscription.applied_promo_code}
      />
      <div className="text-center space-y-4">
        <Button
          variant="link"
          onClick={handleReturnToDashboard}
        >
          Return to Dashboard
        </Button>
        <p className="text-sm text-muted-foreground">
          Have any questions? Call or text <a href="tel:888-817-8857" className="text-[#8BA89F] hover:underline">888-817-8857</a>
        </p>
      </div>
    </div>
  );
};
